<template>
  <!-- 우아한책임 > 윤리경영 -->
  <section :id="hashTitle($t('conduct.title'))" v-bind="$attrs" class="article-anchor esg-ethical">
    <div class="esg-title-wrap">
      <h4 class="esg-title">{{ $t('menuSustainability.ethicalManagement') }}</h4>
    </div>

    <!-- 우아한 바른생활 -->
    <article
      class="esg-box woowalife"
    >
      <div class="esg-box-image">
        <p>
          <img src="~@/static/image/sustainability/image_conduct.jpg" :alt="$t('conduct.name')">
        </p>
      </div>
      <html-view :value="$t('conduct.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('conduct.paragraph1')" class="paragraph paragraph-1" />

        <ol class="list-number">
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('conduct.criterion.item1') }}</strong>
            </p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('conduct.criterion.item2') }}</strong>
            </p>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('conduct.criterion.item3') }}</strong>
            </p>
          </li>
        </ol>

        <html-view :value="$t('conduct.paragraph2')" class="paragraph paragraph-2" />
      </div>
    </article>

    <!-- 윤리강령 -->
    <article
      :id="hashTitle($t('ethical.title'))"
      class="article-anchor esg-box conduct"
    >
      <div class="esg-box-title">
        {{ $t('ethical.title') }}
        <router-link :to="{name: 'ethicalPage', params: { ...localeParams }}" class="btn-link">
          {{ $t('ethical.goDetail') }}
          <icon-blank class="icon-blank" />
        </router-link>
      </div>
      <div class="esg-box-content">
        <div class="conduct-index">
          <p class="conduct-index-title">{{ $t('ethical.title') }}</p>

          <ethical-list />
        </div>
      </div>
    </article>

    <!-- 우아한 바른생활 상담 길라잡이 -->
    <!--<article
      :id="hashTitle($t('counsel.name'))"
      class="article-anchor esg-box counsel"
    >
      <html-view :value="$t('counsel.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <div class="counsel-box">
          <p class="table-caption">{{ $t('counsel.table.caption') }}</p>
          <table class="table">
            <colgroup>
              <col>
              <col style="width:20%">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">{{ $t('counsel.table.th1') }}</th>
                <th scope="col">{{ $t('counsel.table.th2') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('counsel.table.td1') }}</td>
                <td class="center">{{ $t('counsel.table.td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td3') }}</td>
                <td class="center">{{ $t('counsel.table.td4') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td5') }}</td>
                <td class="center">{{ $t('counsel.table.td6') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td7') }}</td>
                <td class="center">{{ $t('counsel.table.td8') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td9') }}</td>
                <td class="center">{{ $t('counsel.table.td10') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td11') }}</td>
                <td class="center">{{ $t('counsel.table.td12') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td13') }}</td>
                <td class="center">{{ $t('counsel.table.td14') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td15') }}</td>
                <td class="center">{{ $t('counsel.table.td16') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td17') }}</td>
                <td class="center">{{ $t('counsel.table.td18') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="counsel-box">
          <html-view :value="$t('credo.title')" tag="p" class="counsel-box-title" />
          <html-view :value="$t('credo.paragraph')" />
        </div>
      </div>
    </article>-->

    <!-- 바른생활 결의문 -->
    <!--<article
      :id="hashTitle($t('resolutions.name'))"
      class="article-anchor esg-box resolutions"
    >
      <h5>{{ $t('resolutions.name') }}</h5>
      <div class="esg-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="../../../static/image/company/pc/image_resolutions@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="../../../static/image/company/m/image_resolutions@3x.jpg 3x">
            <img src="../../../static/image/company/pc/image_resolutions.jpg" :alt="$t('resolutions.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('resolutions.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('resolutions.paragraph')" class="paragraph" />
        <p class="sign">
          <html-view tag="span" :value="$t('resolutions.date')" />
          &lt;!&ndash;          <span><img&ndash;&gt;
          &lt;!&ndash;            src="~@/static/image/sign/kimbeomjun.png"&ndash;&gt;
          &lt;!&ndash;            srcset="~@/static/image/sign/kimbeomjun@2x.png 2x, ~@/static/image/sign/kimbeomjun@3x.png 3x"&ndash;&gt;
          &lt;!&ndash;            :alt="$t('resolutions.sign')"&ndash;&gt;
          &lt;!&ndash;          ></span>&ndash;&gt;
        </p>
      </div>
    </article>-->

    <!-- 바른생활 선언문 -->
    <!--<article
      :id="hashTitle($t('declaration.name'))"
      class="article-anchor esg-box declaration"
    >
      <h5>{{ $t('declaration.name') }}</h5>
      <div class="esg-box-image">
        <p>
          <content-slider
            :pc="[require('@/static/image/company/pc/image_declaration@3x.jpg'), require('@/static/image/company/pc/image_declaration_2@3x.jpg')]"
            :m="[require('@/static/image/company/m/image_declaration@3x.jpg'), require('@/static/image/company/m/image_declaration_2@3x.jpg')]"
          />
        </p>
      </div>
      <html-view :value="$t('declaration.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('declaration.paragraph')" class="paragraph" />
        <p class="sign">
          <html-view tag="span" :value="$t('declaration.date')" />
          <span><img
            src="../../../static/image/sign/kimbongjin.png"
            srcset="../../../static/image/sign/kimbongjin@2x.png 2x, ~@/static/image/sign/kimbongjin@3x.png 3x"
            :alt="$t('declaration.sign')"
          ></span>
        </p>
      </div>
    </article>-->

    <!-- 맺음말 -->
    <article
      :id="hashTitle($t('closing.title'))"
      class="article-anchor esg-box closing"
    >
      <html-view :value="$t('closing.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('closing.paragraph')" class="paragraph" />
      </div>
    </article>
  </section>
</template>
<script>
import gtag from '@/mixins/gtag'
import { hashTitle } from '@/util'
import EthicalList from './EthicalList'
import { mapGetters } from 'vuex'

export default {
  components: {
    EthicalList,
    iconBlank: () => import('@/static/svg/blank.svg')
  },
  mixins: [gtag],
  props: {
    companyMore: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE'
    }),
    localeParams () {
      return {
        locale: this.locale === 'en' ? 'en' : undefined
      }
    }
  },
  mounted () {
    this.$nextTick(this.init)
  },
  methods: {
    hashTitle,
    init () {
      Array.from(document.querySelectorAll('[data-ga]')).forEach(el => {
        this.initGtag({
          element: el,
          isView: true,
          ga: {
            name: '회사소개_지속가능경영',
            category: '회사소개_지속가능경영',
            label: el.dataset.ga,
            page: '회사소개'
          }
        })
      })
    }
  }
}
</script>
